(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/extends", "@babel/runtime/helpers/createClass", "lodash/find", "lodash/map", "promise-sequential", "../../core/ensureArrayValue", "./util"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/extends"), require("@babel/runtime/helpers/createClass"), require("lodash/find"), require("lodash/map"), require("promise-sequential"), require("../../core/ensureArrayValue"), require("./util"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.createClass, global.find, global.map, global.promiseSequential, global.ensureArrayValue, global.util);
    global.Sdk = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _extends2, _createClass2, _find, _map, _promiseSequential, _ensureArrayValue, _util) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  _exports.__esModule = true;
  _exports["default"] = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _find = _interopRequireDefault(_find);
  _map = _interopRequireDefault(_map);
  _promiseSequential = _interopRequireDefault(_promiseSequential);
  _ensureArrayValue = _interopRequireDefault(_ensureArrayValue);

  var Sdk = /*#__PURE__*/function () {
    function Sdk(options) {
      this.options = void 0;
      this.main = void 0;
      this.deferTasks = [];
      this.registeredDirectives = [];
      this.events = void 0;
      this.options = options;
      this.registeredDirectives = options.directiveProcessors || [];
      this.events = options.events;

      if (!this.options.importSdk) {
        throw new Error("importSdk option is required");
      }

      this.loadSdk_();
    }

    var _proto = Sdk.prototype;

    /**
     * 编译并运行这些指令.
     */
    _proto.compile = function compile(directives, options) {
      var _this = this;

      options = options || {
        unmount: false
      };
      var directives_ = (0, _ensureArrayValue["default"])(directives);

      if (!directives_.length) {
        return Promise.reject(new Error("no directives to compile"));
      }

      var seq = (0, _promiseSequential["default"])((0, _map["default"])(directives_, function (directiveDescriptor) {
        return function (previousResponse, responses, count) {
          if (!directiveDescriptor) {
            return Promise.resolve(previousResponse);
          }

          if (!directiveDescriptor.option) {
            // eslint-disable-next-line
            console.warn("!!! direction.option is not exists for: " + directiveDescriptor.name);
          }

          var directiveObj = new _util.DirectiveClass(directiveDescriptor);

          var processor = _this.findDirectiveProcessor_(directiveObj);

          if (!processor) {
            return Promise.reject(new Error("no such directive: " + directiveDescriptor.name));
          }

          var eventName = "vuewx/directive/" + directiveObj.name;
          var isUnmount = !!(options || {}).unmount; // event:start

          _this.events.$emit(eventName, {
            args: directiveObj.argsCount ? directiveObj.args : null,
            phase: "start",
            unmount: isUnmount
          });

          var result = processor.callback(_this, directiveObj, {
            unmount: isUnmount,
            previous: previousResponse,
            count: count,
            directives: directives_
          });

          if (!result || typeof result.then !== "function") {
            var err = new Error("invalid directive, directive callback must return a promise");

            _this.events.$emit(eventName, {
              phase: "reject",
              args: (0, _extends2["default"])({
                error: err
              }, directiveObj.argsCount ? directiveObj.args : null),
              unmount: isUnmount
            });

            return Promise.reject(err);
          } // inject event:end


          return result.then(function (value) {
            _this.events.$emit(eventName, {
              phase: "resolve",
              args: directiveObj.argsCount ? directiveObj.args : null,
              unmount: isUnmount
            });

            return Promise.resolve(value);
          }, function (err) {
            _this.events.$emit(eventName, {
              phase: "reject",
              args: (0, _extends2["default"])({
                error: err
              }, directiveObj.argsCount ? directiveObj.args : null),
              unmount: isUnmount
            });

            return Promise.reject(err);
          });
        };
      }));
      return seq;
    };

    _proto.findDirectiveProcessor_ = function findDirectiveProcessor_(directive) {
      return (0, _find["default"])(this.registeredDirectives, function (directiveProcess) {
        return directiveProcess.name == directive.name;
      });
    }
    /**
     * register directive processor actually.
     */
    ;

    _proto.registerDirective = function registerDirective(name, callback) {
      this.registeredDirectives.push({
        name: name,
        callback: callback
      });
    }
    /**
     * @TODO
     * 可能需要获取 sdk 上面的一些属性.
     */
    ;

    _proto.getOnMain = function getOnMain(path) {
      return path;
    };

    _proto.config = function config(sdkApiConfig, providerApiOptions) {
      var _this2 = this;

      if (this.main) {
        return this.main.config(sdkApiConfig, providerApiOptions);
      } else {
        return new Promise(function (resolve, reject) {
          _this2.loadSdk_().then(function (sdk) {
            sdk.config(sdkApiConfig, providerApiOptions).then(resolve, reject);
          }, reject);
        });
      }
    };

    _proto.exec = function exec() {
      var _this3 = this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (this.main) {
        var _this$main;

        return (_this$main = this.main).exec.apply(_this$main, args);
      }

      return new Promise(function (resolve, reject) {
        _this3.deferTasks.push([function () {
          var _this3$main;

          (_this3$main = _this3.main) == null ? void 0 : _this3$main.exec.apply(_this3$main, args).then(resolve, reject);
        }, reject]);
      });
    }
    /**
     * Run command in sync, no matter is ready or not.
     */
    ;

    _proto.run = function run() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var isReset = args && args[0] === "internal:reset";

      if (isReset) {
        this.deferTasks = [];
        return Promise.resolve(undefined);
      }

      if (this.main) {
        var _this$main2;

        return (_this$main2 = this.main).run.apply(_this$main2, args)["catch"](function (err) {
          if (isReset) {
            return;
          }

          return Promise.reject(err);
        });
      }

      return Promise.reject(new Error("sdk is not ready")); // return new Promise((resolve, reject) => {
      //   this.deferTasks.push([
      //     (main: SdkProvider) => {
      //       main.run(...args).then(resolve, reject);
      //     },
      //     reject,
      //   ]);
      // });
    };

    _proto.ready = function ready() {
      var _this4 = this;

      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      if (this.main) {
        var _this$main3;

        return (_this$main3 = this.main).ready.apply(_this$main3, args);
      }

      return new Promise(function (resolve, reject) {
        _this4.deferTasks.push([function (main) {
          main.ready.apply(main, args).then(resolve, reject);
        }, reject]);
      });
    };

    _proto.loadSdk_ = function loadSdk_() {
      var _this5 = this;

      return this.options.importSdk().then(function (sdk) {
        // @ts-ignore
        if (sdk.__esModule) {
          // @ts-ignore
          sdk = sdk["default"];
        }

        _this5.main = new sdk(_this5.options);

        if (typeof _this5.options.onload === "function") {
          _this5.options.onload(_this5);
        }

        if (_this5.deferTasks.length) {
          _this5.deferTasks.forEach(function (item) {
            item[0](_this5.main);
          });
        }

        return _this5.main;
      }, function (err) {
        return Promise.reject(err);
      });
    };

    (0, _createClass2["default"])(Sdk, [{
      key: "isReady",
      get: function get() {
        if (!this.main) {
          return false;
        }

        return this.main.isReady;
      }
    }]);
    return Sdk;
  }();

  _exports["default"] = Sdk;
});
//# sourceMappingURL=Sdk.js.map